import { medicalDetailsSchema, medicalDetailsType } from "@/src/mocks";
import { reduceTypeToObj } from "@/src/utils/generic-utils";
import { FormProps } from "./form-one";
import FormContainer, { FormSubSectionTitle } from "./form-container";
import BaseButton from "@/src/components/landing-page/button/base-button";
import { CheckRadioButtonGroup } from "@/src/components";

const medicalDetailsLabel = [
  "Any form of heart disease/attack or hypertension?",
  "Any form of cancer?",
  "Any form of stroke?",
  "Any form of kidney disease?",
  "Any form of depression, epilepsy or fit?",
  "Any form of pneumonia, tuberculosis or lungs ailment?",
  "Any form of diabetes?",
  "Any disorder of muscles or bones?",
  "Any other condition not mentioned above?",
];

const medicalDetailsLabelMap = reduceTypeToObj<medicalDetailsType>(
  medicalDetailsLabel,
  medicalDetailsSchema.describe().fields
);

function FormFour({ nextStep, trigger, getValues, control }: FormProps) {
  const values = getValues();
  const dotNotLabel = Object.keys(medicalDetailsSchema.describe().fields).map(
    (el) => el
  );
  async function onValidate(): Promise<void> {
    try {
      await medicalDetailsSchema.validate(values, { abortEarly: false });

      nextStep();
    } catch (error: any) {
      // @ts-ignore
      trigger(dotNotLabel);
      console.error(error.message);
    }
  }

  return (
    <section>
      <FormContainer
        title="We’re almost done!"
        subTitle="Kindly tick as appropriate, to the best of your knowledge"
      >
        <form>
          <div className="py-2">
            <FormSubSectionTitle title="Medical Questionnaire" />
            <div className="my-6">
              <div className="mb-5">
                <CheckRadioButtonGroup
                  name={"hasTreatedHeartDisease"}
                  id={"hasTreatedHeartDisease"}
                  control={control}
                  label={medicalDetailsLabelMap.hasTreatedHeartDisease}
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                />
              </div>
              <div className="mb-5">
                <CheckRadioButtonGroup
                  name={"hasTreatedCancer"}
                  id={"hasTreatedCancer"}
                  control={control}
                  label={medicalDetailsLabelMap.hasTreatedCancer}
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                />
              </div>
              <div className="mb-5">
                <CheckRadioButtonGroup
                  name={"hasTreatedStroke"}
                  id={"hasTreatedStroke"}
                  control={control}
                  label={medicalDetailsLabelMap.hasTreatedStroke}
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                />
              </div>
              <div className="mb-5">
                <CheckRadioButtonGroup
                  name={"hasTreatedDepression"}
                  id={"hasTreatedDepression"}
                  control={control}
                  label={medicalDetailsLabelMap.hasTreatedDepression}
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                />
              </div>
              <div className="mb-5">
                <CheckRadioButtonGroup
                  name={"hasTreatedKidney"}
                  id={"medicalDetails.def"}
                  control={control}
                  label={medicalDetailsLabelMap.hasTreatedKidney}
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                />
              </div>
              <div className="mb-5">
                <CheckRadioButtonGroup
                  name={"hasTreatedLungsAilment"}
                  id={"hasTreatedLungsAilment"}
                  control={control}
                  label={medicalDetailsLabelMap.hasTreatedLungsAilment}
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                />
              </div>
              <div className="mb-5">
                <CheckRadioButtonGroup
                  name={"hasTreatedDiabetes"}
                  id={"hasTreatedDiabetes"}
                  control={control}
                  label={medicalDetailsLabelMap.hasTreatedDiabetes}
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                />
              </div>
              <div className="mb-5">
                <CheckRadioButtonGroup
                  name={"hasTreatedMuscleDisorder"}
                  id={"hasTreatedMuscleDisorder"}
                  control={control}
                  label={medicalDetailsLabelMap.hasTreatedMuscleDisorder}
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                />
              </div>
              <div className="mb-5">
                <CheckRadioButtonGroup
                  name={"hasTreatedAnyOtherCondition"}
                  id={"hasTreatedAnyOtherCondition"}
                  control={control}
                  label={medicalDetailsLabelMap.hasTreatedAnyOtherCondition}
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                />
              </div>
            </div>
          </div>
          <div className="my-6">
            <BaseButton onClick={onValidate} fullWidth>
              Proceed
            </BaseButton>
          </div>
        </form>
      </FormContainer>
    </section>
  );
}

export default FormFour;
